export const IGNORE_SCREENS = [
  "/new_application-signing",
  "/new_application-number-confirmation",
  "/reapplication-signing",
  "/reapplication-number-confirmation",
  "/redirect-continue-application",
  "/registration-esia",
  "/registration-tinkoff",
  "/access-denied",
  "/welcome",
];
